import { render } from "./MenuAksi.vue?vue&type=template&id=64168ed3&scoped=true"
import script from "./MenuAksi.vue?vue&type=script&lang=js"
export * from "./MenuAksi.vue?vue&type=script&lang=js"

import "./MenuAksi.vue?vue&type=style&index=0&id=64168ed3&scoped=true&lang=css"
import "./MenuAksi.vue?vue&type=style&index=1&id=64168ed3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64168ed3"]])

export default __exports__